const RESOURCE_NAME = '/entri';

export default axios => ({
    getToken() {
        return axios.post(`${RESOURCE_NAME}`);// get - /token
    },
    checkDomain(params) {
        return axios.get(`${RESOURCE_NAME}/verify`, {params});
    },
});